import type { EditMode } from "../types/C1_AppTypes";
import type { C1_DisplayMode } from "../types/C1_ModelTypes";

/** Honors the explicit view selection in both apps, with export settings taking precedence. */
export function resolvePlanDisplayMode(_applicationMode: string, _editMode: EditMode, configuredMode: C1_DisplayMode, exportMode?: C1_DisplayMode): C1_DisplayMode {
  return exportMode ?? configuredMode;
}

/** Returns whether structural plan elements use the subdued furnishing presentation. */
export function usesFurnishingPlanPresentation(editMode: EditMode): boolean {
  return editMode === "furnishing" || (editMode === "EloConcept" || editMode === "EloDetail") || editMode === "interactionConcept";
}
